import { useSnackbar } from "notistack";
import React, { useState } from "react";
import ResizeListener from "../../../../../utility/ResizeListener";
import RowButtons from "../../../../../utility/RowButtons";
import { BlackClear } from "../../../../resources/assetsManager";
import {
  BG_COLOR,
  LIGHT_GREY_BG_MODAL,
  WHITE_COLOR,
} from "../../../../resources/colorsManager";

function UpdateConfirmUpi({ onClose, upi, onClickYes }) {
  const { width, height } = ResizeListener();

  const { enqueueSnackbar } = useSnackbar();
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
    minWidth: 280,
    maxWidth: 450,
    marginRight: 20,
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 30px",
        backgroundColor: WHITE_COLOR,
        minWidth: 300,
        borderRadius: 7,
        width: width * 0.32,
        height: "100%",
        alignItems: "center",
        maxHeight: height * 0.5,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: 0,
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          Confirm UPI ID
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontSize: 14,
          }}
        >
          Are you sure you want to change your UPI Id to{" "}
          <span
            style={{
              fontWeight: "600",
              fontFamily: "Roboto",
            }}
          >
            {upi}
          </span>
        </p>
      </div>
      <div
        style={{
          width: "100%",
          margin: "10px 0px",
          marginBottom: 20,
        }}
      >
        <RowButtons
          onClick1={() => {
            onClose();
          }}
          onClick2={() => onClickYes(upi)}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            minWidth: 240,
          }}
          buttonStyle1={{
            width: "40%",
            border: "1px solid dodgerblue",
            borderRadius: 3,
            minWidth: 70,
          }}
          textStyles1={{
            color: "dodgerblue",
          }}
          buttonStyle2={{
            width: "40%",
            backgroundColor: "dodgerblue",
            borderRadius: 3,
            minWidth: 70,
          }}
          buttonTitle2="Confirm"
        />
      </div>
    </div>
  );
}

export default UpdateConfirmUpi;
